import { render, staticRenderFns } from "./TalkUploadDialog.vue?vue&type=template&id=5b3f3d0d&scoped=true"
import script from "./TalkUploadDialog.vue?vue&type=script&lang=js"
export * from "./TalkUploadDialog.vue?vue&type=script&lang=js"
import style0 from "./TalkUploadDialog.vue?vue&type=style&index=0&id=5b3f3d0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3f3d0d",
  null
  
)

export default component.exports